@if (order$ | async; as order) {
  @if (order.consignments?.length || order.unconsignedEntries?.length) {
    @if (orderPromotions$ | async; as orderPromotions) {
      <cx-promotions [promotions]="orderPromotions"></cx-promotions>
    }
  }
  <!-- consigned entries -->
  @if (order.consignments?.length) {
    @if (others$ | async; as others) {
      <cx-order-consigned-entries
        [order]="order"
        [consignments]="others"
      ></cx-order-consigned-entries>
    }
    @if (completed$ | async; as completed) {
      <cx-order-consigned-entries
        [order]="order"
        [consignments]="completed"
      ></cx-order-consigned-entries>
    }
    @if (cancel$ | async; as cancel) {
      <cx-order-consigned-entries
        [order]="order"
        [consignments]="cancel"
      ></cx-order-consigned-entries>
    }
  }
  <!-- unconsigned entries OR any entries -->
  @if (order?.unconsignedEntries?.length ||(order?.entries)) {
    <div class="cx-list row">
      <div class="cx-list-item col-12">
        <cx-cart-item-list
          [items]=" order?.unconsignedEntries ? order.unconsignedEntries : order.entries "
          [readonly]="true"
          [promotionLocation]="promotionLocation"
          [isMyAccount]=true
        ></cx-cart-item-list>
      </div>
    </div>
  }
}
